import React from 'react';
import PropTypes from 'prop-types';
import { ClassNames } from '@emotion/core';
import Carousel from '@domain-group/fe-co-carousel';
import ListingModel from '../../models/listing';
import ListingCard from '../small-card';
import * as styles from './carousel-slide.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class CarouselSlide extends React.Component {
  constructor(props) {
    super(props);
    this.setActiveIndex = this.setActiveIndex.bind(this);
  }
  setActiveIndex(prevIndex, newIndex) {
    // This is quite hacky but the other option was adding the index as a state.
    // This would however re-render the entire component when updated
    // which would be bit overkill for just wanting to update this section.
    // Suggestions for a better solution are welcome.
    if (prevIndex !== newIndex) {
      this.indexBox.innerHTML = newIndex + 1;
    }
  }
  render() {
    var listings = this.props.listings.slice(0, this.props.maxColumns);
    return ___EmotionJSX(ClassNames, null, _ref => {
      var css = _ref.css;
      return ___EmotionJSX("div", null, ___EmotionJSX(Carousel, {
        autoplay: false // this.props.listings.length > 1}
        ,
        autoplaySpeed: 5000,
        infinite: true,
        dots: true,
        dotsClass: css(styles.carouselDots),
        arrows: false,
        slidesToShow: 1,
        beforeChange: this.setActiveIndex
      }, listings.map((listing, index) => ___EmotionJSX("div", {
        key: listing.url
      }, ___EmotionJSX(ListingCard, {
        displayType: "carousel",
        title: this.props.title,
        onClick: () => {
          this.props.onClick(listing, index);
        },
        listing: listing,
        appearance: "sidebar"
      })))), ___EmotionJSX("div", {
        css: styles.sliderPage
      }, ___EmotionJSX("span", {
        ref: indexBox => {
          this.indexBox = indexBox;
        }
      }, "1"), "/", listings.length));
    });
  }
}
CarouselSlide.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.shape(ListingModel)),
  maxColumns: PropTypes.number,
  title: PropTypes.string,
  onClick: PropTypes.func
};
CarouselSlide.defaultProps = {
  listings: [],
  maxColumns: undefined,
  title: 'Property of the Week',
  onClick: () => {}
};
export default CarouselSlide;